import React from "react";

import AvatarPng from "../../../images/profile/avatar-0.png";
import Avatar1Png from "../../../images/profile/avatar-1.png";
import Avatar2Png from "../../../images/profile/avatar-2.png";
import Avatar3Png from "../../../images/profile/avatar-3.png";
import Avatar4Png from "../../../images/profile/avatar-4.png";
import Avatar5Png from "../../../images/profile/avatar-5.png";
import lawoneLogo from "../../../images/logo_white_bg.png";
import PersonLogo from "../../../images/person.png";

function AvatarPreview({ src, isSvg, style, ...props }) {
  switch (src === 0 || src ? +src : undefined) {
    case 0:
      return (
        <img
          className={["avatar-style", style && style].join(" ")}
          src={AvatarPng}
          alt="avatar-0"
          {...props}
        />
      );
    case 1:
      return (
        <img
          className={["avatar-style", style && style].join(" ")}
          src={Avatar1Png}
          alt="avatar-1"
          {...props}
        />
      );
    case 2:
      return (
        <img
          className={["avatar-style", style && style].join(" ")}
          src={Avatar2Png}
          alt="avatar-2"
          {...props}
        />
      );
    case 3:
      return (
        <img
          className={["avatar-style", style && style].join(" ")}
          src={Avatar3Png}
          alt="avatar-3"
          {...props}
        />
      );
    case 4:
      return (
        <img
          className={["avatar-style", style && style].join(" ")}
          src={Avatar4Png}
          alt="avatar-4"
          {...props}
        />
      );
    case 5:
      return (
        <img
          className={["avatar-style", style && style].join(" ")}
          src={Avatar5Png}
          alt="avatar-5"
          {...props}
        />
      );
    case 6:
      return (
        <img
          className={["avatar-style", style && style].join(" ")}
          src={Avatar3Png}
          alt="avatar-3"
          {...props}
        />
      );
    case 7:
      return (
        <img
          className={["avatar-style", style && style].join(" ")}
          src={lawoneLogo}
          alt="lawoneLogo"
          {...props}
        />
      );
    default:
      return (
        <img
          className={["avatar-style", style && style].join(" ")}
          src={PersonLogo}
          alt="lawoneLogo"
          {...props}
        />
      );
  }
}

export default AvatarPreview;
